export default __webpack_public_path__ + "static/media/readingGoal.fda100ac.jpg";